import { Component, OnInit } from '@angular/core';
import { getEmptyUser } from 'src/app/interfaces/user';
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/user.service';
import { Thumbs } from 'swiper';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent implements OnInit {
  user: any;

  roles: any[] = [
    { role: "COMPANY_ADMIN", name: "Admin" },
    { role: "EMPLOYEE", name: "Mitarbeiter" },
    // { role: "CUSTOMER", name: "Admin" },
    // { role: "CALENDAR_ADMIN", name: "Admin" },
    // {role:"SUPERUSER",name:"Admin"}
  ]
  // selectRole = document.getElementById('customPopoverSelect');
  // customPopoverOptions = {
  //   header: 'Wähle deine Role',
  //   subHeader: 'los gehts',
  //   message: 'Only select your dominant hair color'
  // };

  constructor(
    private userService: UserService,
    private toastS: ToastService
  ) {
    console.log(this.selectRole);
    // this.user = getEmptyUser();
    this.userService.userDataSubject.subscribe(x => {
      this.user = x;
      console.log("theUSER: ", this.user);
    })
  }

  ngOnInit() {
    console.log("USER", this.user)
  }

  save() {
    this.userService.saveUser(this.user).subscribe(x => {
      this.userService.userSave.next(x);
      //TODO: toastmessage
      this.toastS.addToast();
      console.log("user wurde gespeichert", this.user);
    }, err => {
      this.toastS.addToastNot();
      console.log("user wurde nicht gespeichert", this.user);
    });
  }

  selectRole(role) {
    console.log(role);
  }

  // checkRole(role) {
  //   switch (role) {
  //     case 'COMPANY_ADMIN':
  //       return 'Admin'
  //     case 'EMPLOYEE':
  //       return 'Benutzer'
  //       break;
  //     default:
  //       break;
  //   }
  // }
}

